import { render, staticRenderFns } from "./MyNotifyList.vue?vue&type=template&id=5de33c47"
import script from "./MyNotifyList.vue?vue&type=script&lang=js"
export * from "./MyNotifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de33c47')) {
      api.createRecord('5de33c47', component.options)
    } else {
      api.reload('5de33c47', component.options)
    }
    module.hot.accept("./MyNotifyList.vue?vue&type=template&id=5de33c47", function () {
      api.rerender('5de33c47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/notify/MyNotifyList.vue"
export default component.exports